/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AktivaceRouteImport } from './routes/aktivace'
import { Route as FotografRouteRouteImport } from './routes/fotograf/route'
import { Route as KlientRouteRouteImport } from './routes/klient/route'
import { Route as PrihlaseniRouteImport } from './routes/prihlaseni'
import { Route as SpravceRouteRouteImport } from './routes/spravce/route'
import { Route as FotografIndexRouteImport } from './routes/fotograf/index'
import { Route as FotografChatRouteImport } from './routes/fotograf/chat'
import { Route as FotografDostupnostRouteImport } from './routes/fotograf/dostupnost'
import { Route as FotografPrehledRouteImport } from './routes/fotograf/prehled'
import { Route as FotografProfilRouteImport } from './routes/fotograf/profil'
import { Route as FotografVydelkyRouteImport } from './routes/fotograf/vydelky'
import { Route as KlientIndexRouteImport } from './routes/klient/index'
import { Route as KlientChatRouteImport } from './routes/klient/chat'
import { Route as KlientKnihovnaRouteImport } from './routes/klient/knihovna'
import { Route as KlientPlanRouteImport } from './routes/klient/plan'
import { Route as KlientPrehledRouteImport } from './routes/klient/prehled'
import { Route as OnboardingIndexRouteImport } from './routes/onboarding/index'
import { Route as OnboardingFoceniRouteImport } from './routes/onboarding/foceni'
import { Route as OnboardingHlasRouteImport } from './routes/onboarding/hlas'
import { Route as OnboardingHotovoRouteImport } from './routes/onboarding/hotovo'
import { Route as OnboardingListkyRouteImport } from './routes/onboarding/listky'
import { Route as OnboardingNapojeniRouteImport } from './routes/onboarding/napojeni'
import { Route as OnboardingOdkazyRouteImport } from './routes/onboarding/odkazy'
import { Route as OnboardingPodnikRouteImport } from './routes/onboarding/podnik'
import { Route as OnboardingVitejteRouteImport } from './routes/onboarding/vitejte'
import { Route as OnboardingZnackaRouteImport } from './routes/onboarding/znacka'
import { Route as SpravceIndexRouteImport } from './routes/spravce/index'
import { Route as SpravcePlanyRouteImport } from './routes/spravce/plany'
import { Route as SpravcePrehledRouteImport } from './routes/spravce/prehled'
import { Route as SpravceProfilRouteImport } from './routes/spravce/profil'
import { Route as FotografFoceniShootRouteImport } from './routes/fotograf/foceni/$shoot'
import { Route as FotografKnihovnaIndexRouteImport } from './routes/fotograf/knihovna/index'
import { Route as FotografKnihovnaVenueRouteImport } from './routes/fotograf/knihovna/$venue'
import { Route as KlientFoceniIndexRouteImport } from './routes/klient/foceni/index'
import { Route as KlientFoceniBriefRouteImport } from './routes/klient/foceni/brief'
import { Route as KlientProfilIndexRouteImport } from './routes/klient/profil/index'
import { Route as KlientProfilFakturaceRouteImport } from './routes/klient/profil/fakturace'
import { Route as KlientProfilNastaveniRouteImport } from './routes/klient/profil/nastaveni'
import { Route as KlientProfilPodkladyRouteImport } from './routes/klient/profil/podklady'
import { Route as SpravceChatyIndexRouteImport } from './routes/spravce/chaty/index'
import { Route as SpravceChatyClientRouteImport } from './routes/spravce/chaty/$client'
import { Route as SpravceFoceniShootRouteImport } from './routes/spravce/foceni/$shoot'
import { Route as SpravceKlientiIndexRouteImport } from './routes/spravce/klienti/index'
import { Route as SpravceKlientiClientRouteImport } from './routes/spravce/klienti/$client'
import { Route as SpravceKontrolaClientRouteImport } from './routes/spravce/kontrola/$client'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AktivaceRoute = AktivaceRouteImport.update({
  id: '/aktivace',
  path: '/aktivace',
  getParentRoute: () => rootRouteImport,
} as any)
const FotografRouteRoute = FotografRouteRouteImport.update({
  id: '/fotograf',
  path: '/fotograf',
  getParentRoute: () => rootRouteImport,
} as any)
const KlientRouteRoute = KlientRouteRouteImport.update({
  id: '/klient',
  path: '/klient',
  getParentRoute: () => rootRouteImport,
} as any)
const PrihlaseniRoute = PrihlaseniRouteImport.update({
  id: '/prihlaseni',
  path: '/prihlaseni',
  getParentRoute: () => rootRouteImport,
} as any)
const SpravceRouteRoute = SpravceRouteRouteImport.update({
  id: '/spravce',
  path: '/spravce',
  getParentRoute: () => rootRouteImport,
} as any)
const FotografIndexRoute = FotografIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FotografRouteRoute,
} as any)
const FotografChatRoute = FotografChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => FotografRouteRoute,
} as any)
const FotografDostupnostRoute = FotografDostupnostRouteImport.update({
  id: '/dostupnost',
  path: '/dostupnost',
  getParentRoute: () => FotografRouteRoute,
} as any)
const FotografPrehledRoute = FotografPrehledRouteImport.update({
  id: '/prehled',
  path: '/prehled',
  getParentRoute: () => FotografRouteRoute,
} as any)
const FotografProfilRoute = FotografProfilRouteImport.update({
  id: '/profil',
  path: '/profil',
  getParentRoute: () => FotografRouteRoute,
} as any)
const FotografVydelkyRoute = FotografVydelkyRouteImport.update({
  id: '/vydelky',
  path: '/vydelky',
  getParentRoute: () => FotografRouteRoute,
} as any)
const KlientIndexRoute = KlientIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => KlientRouteRoute,
} as any)
const KlientChatRoute = KlientChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => KlientRouteRoute,
} as any)
const KlientKnihovnaRoute = KlientKnihovnaRouteImport.update({
  id: '/knihovna',
  path: '/knihovna',
  getParentRoute: () => KlientRouteRoute,
} as any)
const KlientPlanRoute = KlientPlanRouteImport.update({
  id: '/plan',
  path: '/plan',
  getParentRoute: () => KlientRouteRoute,
} as any)
const KlientPrehledRoute = KlientPrehledRouteImport.update({
  id: '/prehled',
  path: '/prehled',
  getParentRoute: () => KlientRouteRoute,
} as any)
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/onboarding/',
  path: '/onboarding/',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingFoceniRoute = OnboardingFoceniRouteImport.update({
  id: '/onboarding/foceni',
  path: '/onboarding/foceni',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingHlasRoute = OnboardingHlasRouteImport.update({
  id: '/onboarding/hlas',
  path: '/onboarding/hlas',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingHotovoRoute = OnboardingHotovoRouteImport.update({
  id: '/onboarding/hotovo',
  path: '/onboarding/hotovo',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingListkyRoute = OnboardingListkyRouteImport.update({
  id: '/onboarding/listky',
  path: '/onboarding/listky',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingNapojeniRoute = OnboardingNapojeniRouteImport.update({
  id: '/onboarding/napojeni',
  path: '/onboarding/napojeni',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingOdkazyRoute = OnboardingOdkazyRouteImport.update({
  id: '/onboarding/odkazy',
  path: '/onboarding/odkazy',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingPodnikRoute = OnboardingPodnikRouteImport.update({
  id: '/onboarding/podnik',
  path: '/onboarding/podnik',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingVitejteRoute = OnboardingVitejteRouteImport.update({
  id: '/onboarding/vitejte',
  path: '/onboarding/vitejte',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingZnackaRoute = OnboardingZnackaRouteImport.update({
  id: '/onboarding/znacka',
  path: '/onboarding/znacka',
  getParentRoute: () => rootRouteImport,
} as any)
const SpravceIndexRoute = SpravceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SpravceRouteRoute,
} as any)
const SpravcePlanyRoute = SpravcePlanyRouteImport.update({
  id: '/plany',
  path: '/plany',
  getParentRoute: () => SpravceRouteRoute,
} as any)
const SpravcePrehledRoute = SpravcePrehledRouteImport.update({
  id: '/prehled',
  path: '/prehled',
  getParentRoute: () => SpravceRouteRoute,
} as any)
const SpravceProfilRoute = SpravceProfilRouteImport.update({
  id: '/profil',
  path: '/profil',
  getParentRoute: () => SpravceRouteRoute,
} as any)
const FotografFoceniShootRoute = FotografFoceniShootRouteImport.update({
  id: '/foceni/$shoot',
  path: '/foceni/$shoot',
  getParentRoute: () => FotografRouteRoute,
} as any)
const FotografKnihovnaIndexRoute = FotografKnihovnaIndexRouteImport.update({
  id: '/knihovna/',
  path: '/knihovna/',
  getParentRoute: () => FotografRouteRoute,
} as any)
const FotografKnihovnaVenueRoute = FotografKnihovnaVenueRouteImport.update({
  id: '/knihovna/$venue',
  path: '/knihovna/$venue',
  getParentRoute: () => FotografRouteRoute,
} as any)
const KlientFoceniIndexRoute = KlientFoceniIndexRouteImport.update({
  id: '/foceni/',
  path: '/foceni/',
  getParentRoute: () => KlientRouteRoute,
} as any)
const KlientFoceniBriefRoute = KlientFoceniBriefRouteImport.update({
  id: '/foceni/brief',
  path: '/foceni/brief',
  getParentRoute: () => KlientRouteRoute,
} as any)
const KlientProfilIndexRoute = KlientProfilIndexRouteImport.update({
  id: '/profil/',
  path: '/profil/',
  getParentRoute: () => KlientRouteRoute,
} as any)
const KlientProfilFakturaceRoute = KlientProfilFakturaceRouteImport.update({
  id: '/profil/fakturace',
  path: '/profil/fakturace',
  getParentRoute: () => KlientRouteRoute,
} as any)
const KlientProfilNastaveniRoute = KlientProfilNastaveniRouteImport.update({
  id: '/profil/nastaveni',
  path: '/profil/nastaveni',
  getParentRoute: () => KlientRouteRoute,
} as any)
const KlientProfilPodkladyRoute = KlientProfilPodkladyRouteImport.update({
  id: '/profil/podklady',
  path: '/profil/podklady',
  getParentRoute: () => KlientRouteRoute,
} as any)
const SpravceChatyIndexRoute = SpravceChatyIndexRouteImport.update({
  id: '/chaty/',
  path: '/chaty/',
  getParentRoute: () => SpravceRouteRoute,
} as any)
const SpravceChatyClientRoute = SpravceChatyClientRouteImport.update({
  id: '/chaty/$client',
  path: '/chaty/$client',
  getParentRoute: () => SpravceRouteRoute,
} as any)
const SpravceFoceniShootRoute = SpravceFoceniShootRouteImport.update({
  id: '/foceni/$shoot',
  path: '/foceni/$shoot',
  getParentRoute: () => SpravceRouteRoute,
} as any)
const SpravceKlientiIndexRoute = SpravceKlientiIndexRouteImport.update({
  id: '/klienti/',
  path: '/klienti/',
  getParentRoute: () => SpravceRouteRoute,
} as any)
const SpravceKlientiClientRoute = SpravceKlientiClientRouteImport.update({
  id: '/klienti/$client',
  path: '/klienti/$client',
  getParentRoute: () => SpravceRouteRoute,
} as any)
const SpravceKontrolaClientRoute = SpravceKontrolaClientRouteImport.update({
  id: '/kontrola/$client',
  path: '/kontrola/$client',
  getParentRoute: () => SpravceRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/fotograf': typeof FotografRouteRouteWithChildren
  '/klient': typeof KlientRouteRouteWithChildren
  '/spravce': typeof SpravceRouteRouteWithChildren
  '/aktivace': typeof AktivaceRoute
  '/prihlaseni': typeof PrihlaseniRoute
  '/fotograf/chat': typeof FotografChatRoute
  '/fotograf/dostupnost': typeof FotografDostupnostRoute
  '/fotograf/prehled': typeof FotografPrehledRoute
  '/fotograf/profil': typeof FotografProfilRoute
  '/fotograf/vydelky': typeof FotografVydelkyRoute
  '/klient/chat': typeof KlientChatRoute
  '/klient/knihovna': typeof KlientKnihovnaRoute
  '/klient/plan': typeof KlientPlanRoute
  '/klient/prehled': typeof KlientPrehledRoute
  '/onboarding/foceni': typeof OnboardingFoceniRoute
  '/onboarding/hlas': typeof OnboardingHlasRoute
  '/onboarding/hotovo': typeof OnboardingHotovoRoute
  '/onboarding/listky': typeof OnboardingListkyRoute
  '/onboarding/napojeni': typeof OnboardingNapojeniRoute
  '/onboarding/odkazy': typeof OnboardingOdkazyRoute
  '/onboarding/podnik': typeof OnboardingPodnikRoute
  '/onboarding/vitejte': typeof OnboardingVitejteRoute
  '/onboarding/znacka': typeof OnboardingZnackaRoute
  '/spravce/plany': typeof SpravcePlanyRoute
  '/spravce/prehled': typeof SpravcePrehledRoute
  '/spravce/profil': typeof SpravceProfilRoute
  '/fotograf/': typeof FotografIndexRoute
  '/klient/': typeof KlientIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/spravce/': typeof SpravceIndexRoute
  '/fotograf/foceni/$shoot': typeof FotografFoceniShootRoute
  '/fotograf/knihovna/$venue': typeof FotografKnihovnaVenueRoute
  '/klient/foceni/brief': typeof KlientFoceniBriefRoute
  '/klient/profil/fakturace': typeof KlientProfilFakturaceRoute
  '/klient/profil/nastaveni': typeof KlientProfilNastaveniRoute
  '/klient/profil/podklady': typeof KlientProfilPodkladyRoute
  '/spravce/chaty/$client': typeof SpravceChatyClientRoute
  '/spravce/foceni/$shoot': typeof SpravceFoceniShootRoute
  '/spravce/klienti/$client': typeof SpravceKlientiClientRoute
  '/spravce/kontrola/$client': typeof SpravceKontrolaClientRoute
  '/fotograf/knihovna/': typeof FotografKnihovnaIndexRoute
  '/klient/foceni/': typeof KlientFoceniIndexRoute
  '/klient/profil/': typeof KlientProfilIndexRoute
  '/spravce/chaty/': typeof SpravceChatyIndexRoute
  '/spravce/klienti/': typeof SpravceKlientiIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/aktivace': typeof AktivaceRoute
  '/prihlaseni': typeof PrihlaseniRoute
  '/fotograf/chat': typeof FotografChatRoute
  '/fotograf/dostupnost': typeof FotografDostupnostRoute
  '/fotograf/prehled': typeof FotografPrehledRoute
  '/fotograf/profil': typeof FotografProfilRoute
  '/fotograf/vydelky': typeof FotografVydelkyRoute
  '/klient/chat': typeof KlientChatRoute
  '/klient/knihovna': typeof KlientKnihovnaRoute
  '/klient/plan': typeof KlientPlanRoute
  '/klient/prehled': typeof KlientPrehledRoute
  '/onboarding/foceni': typeof OnboardingFoceniRoute
  '/onboarding/hlas': typeof OnboardingHlasRoute
  '/onboarding/hotovo': typeof OnboardingHotovoRoute
  '/onboarding/listky': typeof OnboardingListkyRoute
  '/onboarding/napojeni': typeof OnboardingNapojeniRoute
  '/onboarding/odkazy': typeof OnboardingOdkazyRoute
  '/onboarding/podnik': typeof OnboardingPodnikRoute
  '/onboarding/vitejte': typeof OnboardingVitejteRoute
  '/onboarding/znacka': typeof OnboardingZnackaRoute
  '/spravce/plany': typeof SpravcePlanyRoute
  '/spravce/prehled': typeof SpravcePrehledRoute
  '/spravce/profil': typeof SpravceProfilRoute
  '/fotograf': typeof FotografIndexRoute
  '/klient': typeof KlientIndexRoute
  '/onboarding': typeof OnboardingIndexRoute
  '/spravce': typeof SpravceIndexRoute
  '/fotograf/foceni/$shoot': typeof FotografFoceniShootRoute
  '/fotograf/knihovna/$venue': typeof FotografKnihovnaVenueRoute
  '/klient/foceni/brief': typeof KlientFoceniBriefRoute
  '/klient/profil/fakturace': typeof KlientProfilFakturaceRoute
  '/klient/profil/nastaveni': typeof KlientProfilNastaveniRoute
  '/klient/profil/podklady': typeof KlientProfilPodkladyRoute
  '/spravce/chaty/$client': typeof SpravceChatyClientRoute
  '/spravce/foceni/$shoot': typeof SpravceFoceniShootRoute
  '/spravce/klienti/$client': typeof SpravceKlientiClientRoute
  '/spravce/kontrola/$client': typeof SpravceKontrolaClientRoute
  '/fotograf/knihovna': typeof FotografKnihovnaIndexRoute
  '/klient/foceni': typeof KlientFoceniIndexRoute
  '/klient/profil': typeof KlientProfilIndexRoute
  '/spravce/chaty': typeof SpravceChatyIndexRoute
  '/spravce/klienti': typeof SpravceKlientiIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/fotograf': typeof FotografRouteRouteWithChildren
  '/klient': typeof KlientRouteRouteWithChildren
  '/spravce': typeof SpravceRouteRouteWithChildren
  '/aktivace': typeof AktivaceRoute
  '/prihlaseni': typeof PrihlaseniRoute
  '/fotograf/chat': typeof FotografChatRoute
  '/fotograf/dostupnost': typeof FotografDostupnostRoute
  '/fotograf/prehled': typeof FotografPrehledRoute
  '/fotograf/profil': typeof FotografProfilRoute
  '/fotograf/vydelky': typeof FotografVydelkyRoute
  '/klient/chat': typeof KlientChatRoute
  '/klient/knihovna': typeof KlientKnihovnaRoute
  '/klient/plan': typeof KlientPlanRoute
  '/klient/prehled': typeof KlientPrehledRoute
  '/onboarding/foceni': typeof OnboardingFoceniRoute
  '/onboarding/hlas': typeof OnboardingHlasRoute
  '/onboarding/hotovo': typeof OnboardingHotovoRoute
  '/onboarding/listky': typeof OnboardingListkyRoute
  '/onboarding/napojeni': typeof OnboardingNapojeniRoute
  '/onboarding/odkazy': typeof OnboardingOdkazyRoute
  '/onboarding/podnik': typeof OnboardingPodnikRoute
  '/onboarding/vitejte': typeof OnboardingVitejteRoute
  '/onboarding/znacka': typeof OnboardingZnackaRoute
  '/spravce/plany': typeof SpravcePlanyRoute
  '/spravce/prehled': typeof SpravcePrehledRoute
  '/spravce/profil': typeof SpravceProfilRoute
  '/fotograf/': typeof FotografIndexRoute
  '/klient/': typeof KlientIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/spravce/': typeof SpravceIndexRoute
  '/fotograf/foceni/$shoot': typeof FotografFoceniShootRoute
  '/fotograf/knihovna/$venue': typeof FotografKnihovnaVenueRoute
  '/klient/foceni/brief': typeof KlientFoceniBriefRoute
  '/klient/profil/fakturace': typeof KlientProfilFakturaceRoute
  '/klient/profil/nastaveni': typeof KlientProfilNastaveniRoute
  '/klient/profil/podklady': typeof KlientProfilPodkladyRoute
  '/spravce/chaty/$client': typeof SpravceChatyClientRoute
  '/spravce/foceni/$shoot': typeof SpravceFoceniShootRoute
  '/spravce/klienti/$client': typeof SpravceKlientiClientRoute
  '/spravce/kontrola/$client': typeof SpravceKontrolaClientRoute
  '/fotograf/knihovna/': typeof FotografKnihovnaIndexRoute
  '/klient/foceni/': typeof KlientFoceniIndexRoute
  '/klient/profil/': typeof KlientProfilIndexRoute
  '/spravce/chaty/': typeof SpravceChatyIndexRoute
  '/spravce/klienti/': typeof SpravceKlientiIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/fotograf'
    | '/klient'
    | '/spravce'
    | '/aktivace'
    | '/prihlaseni'
    | '/fotograf/chat'
    | '/fotograf/dostupnost'
    | '/fotograf/prehled'
    | '/fotograf/profil'
    | '/fotograf/vydelky'
    | '/klient/chat'
    | '/klient/knihovna'
    | '/klient/plan'
    | '/klient/prehled'
    | '/onboarding/foceni'
    | '/onboarding/hlas'
    | '/onboarding/hotovo'
    | '/onboarding/listky'
    | '/onboarding/napojeni'
    | '/onboarding/odkazy'
    | '/onboarding/podnik'
    | '/onboarding/vitejte'
    | '/onboarding/znacka'
    | '/spravce/plany'
    | '/spravce/prehled'
    | '/spravce/profil'
    | '/fotograf/'
    | '/klient/'
    | '/onboarding/'
    | '/spravce/'
    | '/fotograf/foceni/$shoot'
    | '/fotograf/knihovna/$venue'
    | '/klient/foceni/brief'
    | '/klient/profil/fakturace'
    | '/klient/profil/nastaveni'
    | '/klient/profil/podklady'
    | '/spravce/chaty/$client'
    | '/spravce/foceni/$shoot'
    | '/spravce/klienti/$client'
    | '/spravce/kontrola/$client'
    | '/fotograf/knihovna/'
    | '/klient/foceni/'
    | '/klient/profil/'
    | '/spravce/chaty/'
    | '/spravce/klienti/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/aktivace'
    | '/prihlaseni'
    | '/fotograf/chat'
    | '/fotograf/dostupnost'
    | '/fotograf/prehled'
    | '/fotograf/profil'
    | '/fotograf/vydelky'
    | '/klient/chat'
    | '/klient/knihovna'
    | '/klient/plan'
    | '/klient/prehled'
    | '/onboarding/foceni'
    | '/onboarding/hlas'
    | '/onboarding/hotovo'
    | '/onboarding/listky'
    | '/onboarding/napojeni'
    | '/onboarding/odkazy'
    | '/onboarding/podnik'
    | '/onboarding/vitejte'
    | '/onboarding/znacka'
    | '/spravce/plany'
    | '/spravce/prehled'
    | '/spravce/profil'
    | '/fotograf'
    | '/klient'
    | '/onboarding'
    | '/spravce'
    | '/fotograf/foceni/$shoot'
    | '/fotograf/knihovna/$venue'
    | '/klient/foceni/brief'
    | '/klient/profil/fakturace'
    | '/klient/profil/nastaveni'
    | '/klient/profil/podklady'
    | '/spravce/chaty/$client'
    | '/spravce/foceni/$shoot'
    | '/spravce/klienti/$client'
    | '/spravce/kontrola/$client'
    | '/fotograf/knihovna'
    | '/klient/foceni'
    | '/klient/profil'
    | '/spravce/chaty'
    | '/spravce/klienti'
  id:
    | '__root__'
    | '/'
    | '/fotograf'
    | '/klient'
    | '/spravce'
    | '/aktivace'
    | '/prihlaseni'
    | '/fotograf/chat'
    | '/fotograf/dostupnost'
    | '/fotograf/prehled'
    | '/fotograf/profil'
    | '/fotograf/vydelky'
    | '/klient/chat'
    | '/klient/knihovna'
    | '/klient/plan'
    | '/klient/prehled'
    | '/onboarding/foceni'
    | '/onboarding/hlas'
    | '/onboarding/hotovo'
    | '/onboarding/listky'
    | '/onboarding/napojeni'
    | '/onboarding/odkazy'
    | '/onboarding/podnik'
    | '/onboarding/vitejte'
    | '/onboarding/znacka'
    | '/spravce/plany'
    | '/spravce/prehled'
    | '/spravce/profil'
    | '/fotograf/'
    | '/klient/'
    | '/onboarding/'
    | '/spravce/'
    | '/fotograf/foceni/$shoot'
    | '/fotograf/knihovna/$venue'
    | '/klient/foceni/brief'
    | '/klient/profil/fakturace'
    | '/klient/profil/nastaveni'
    | '/klient/profil/podklady'
    | '/spravce/chaty/$client'
    | '/spravce/foceni/$shoot'
    | '/spravce/klienti/$client'
    | '/spravce/kontrola/$client'
    | '/fotograf/knihovna/'
    | '/klient/foceni/'
    | '/klient/profil/'
    | '/spravce/chaty/'
    | '/spravce/klienti/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  FotografRouteRoute: typeof FotografRouteRouteWithChildren
  KlientRouteRoute: typeof KlientRouteRouteWithChildren
  SpravceRouteRoute: typeof SpravceRouteRouteWithChildren
  AktivaceRoute: typeof AktivaceRoute
  PrihlaseniRoute: typeof PrihlaseniRoute
  OnboardingFoceniRoute: typeof OnboardingFoceniRoute
  OnboardingHlasRoute: typeof OnboardingHlasRoute
  OnboardingHotovoRoute: typeof OnboardingHotovoRoute
  OnboardingListkyRoute: typeof OnboardingListkyRoute
  OnboardingNapojeniRoute: typeof OnboardingNapojeniRoute
  OnboardingOdkazyRoute: typeof OnboardingOdkazyRoute
  OnboardingPodnikRoute: typeof OnboardingPodnikRoute
  OnboardingVitejteRoute: typeof OnboardingVitejteRoute
  OnboardingZnackaRoute: typeof OnboardingZnackaRoute
  OnboardingIndexRoute: typeof OnboardingIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/aktivace': {
      id: '/aktivace'
      path: '/aktivace'
      fullPath: '/aktivace'
      preLoaderRoute: typeof AktivaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fotograf': {
      id: '/fotograf'
      path: '/fotograf'
      fullPath: '/fotograf'
      preLoaderRoute: typeof FotografRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/klient': {
      id: '/klient'
      path: '/klient'
      fullPath: '/klient'
      preLoaderRoute: typeof KlientRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prihlaseni': {
      id: '/prihlaseni'
      path: '/prihlaseni'
      fullPath: '/prihlaseni'
      preLoaderRoute: typeof PrihlaseniRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/spravce': {
      id: '/spravce'
      path: '/spravce'
      fullPath: '/spravce'
      preLoaderRoute: typeof SpravceRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fotograf/': {
      id: '/fotograf/'
      path: '/'
      fullPath: '/fotograf/'
      preLoaderRoute: typeof FotografIndexRouteImport
      parentRoute: typeof FotografRouteRoute
    }
    '/fotograf/chat': {
      id: '/fotograf/chat'
      path: '/chat'
      fullPath: '/fotograf/chat'
      preLoaderRoute: typeof FotografChatRouteImport
      parentRoute: typeof FotografRouteRoute
    }
    '/fotograf/dostupnost': {
      id: '/fotograf/dostupnost'
      path: '/dostupnost'
      fullPath: '/fotograf/dostupnost'
      preLoaderRoute: typeof FotografDostupnostRouteImport
      parentRoute: typeof FotografRouteRoute
    }
    '/fotograf/prehled': {
      id: '/fotograf/prehled'
      path: '/prehled'
      fullPath: '/fotograf/prehled'
      preLoaderRoute: typeof FotografPrehledRouteImport
      parentRoute: typeof FotografRouteRoute
    }
    '/fotograf/profil': {
      id: '/fotograf/profil'
      path: '/profil'
      fullPath: '/fotograf/profil'
      preLoaderRoute: typeof FotografProfilRouteImport
      parentRoute: typeof FotografRouteRoute
    }
    '/fotograf/vydelky': {
      id: '/fotograf/vydelky'
      path: '/vydelky'
      fullPath: '/fotograf/vydelky'
      preLoaderRoute: typeof FotografVydelkyRouteImport
      parentRoute: typeof FotografRouteRoute
    }
    '/klient/': {
      id: '/klient/'
      path: '/'
      fullPath: '/klient/'
      preLoaderRoute: typeof KlientIndexRouteImport
      parentRoute: typeof KlientRouteRoute
    }
    '/klient/chat': {
      id: '/klient/chat'
      path: '/chat'
      fullPath: '/klient/chat'
      preLoaderRoute: typeof KlientChatRouteImport
      parentRoute: typeof KlientRouteRoute
    }
    '/klient/knihovna': {
      id: '/klient/knihovna'
      path: '/knihovna'
      fullPath: '/klient/knihovna'
      preLoaderRoute: typeof KlientKnihovnaRouteImport
      parentRoute: typeof KlientRouteRoute
    }
    '/klient/plan': {
      id: '/klient/plan'
      path: '/plan'
      fullPath: '/klient/plan'
      preLoaderRoute: typeof KlientPlanRouteImport
      parentRoute: typeof KlientRouteRoute
    }
    '/klient/prehled': {
      id: '/klient/prehled'
      path: '/prehled'
      fullPath: '/klient/prehled'
      preLoaderRoute: typeof KlientPrehledRouteImport
      parentRoute: typeof KlientRouteRoute
    }
    '/onboarding/': {
      id: '/onboarding/'
      path: '/onboarding'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof OnboardingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/foceni': {
      id: '/onboarding/foceni'
      path: '/onboarding/foceni'
      fullPath: '/onboarding/foceni'
      preLoaderRoute: typeof OnboardingFoceniRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/hlas': {
      id: '/onboarding/hlas'
      path: '/onboarding/hlas'
      fullPath: '/onboarding/hlas'
      preLoaderRoute: typeof OnboardingHlasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/hotovo': {
      id: '/onboarding/hotovo'
      path: '/onboarding/hotovo'
      fullPath: '/onboarding/hotovo'
      preLoaderRoute: typeof OnboardingHotovoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/listky': {
      id: '/onboarding/listky'
      path: '/onboarding/listky'
      fullPath: '/onboarding/listky'
      preLoaderRoute: typeof OnboardingListkyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/napojeni': {
      id: '/onboarding/napojeni'
      path: '/onboarding/napojeni'
      fullPath: '/onboarding/napojeni'
      preLoaderRoute: typeof OnboardingNapojeniRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/odkazy': {
      id: '/onboarding/odkazy'
      path: '/onboarding/odkazy'
      fullPath: '/onboarding/odkazy'
      preLoaderRoute: typeof OnboardingOdkazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/podnik': {
      id: '/onboarding/podnik'
      path: '/onboarding/podnik'
      fullPath: '/onboarding/podnik'
      preLoaderRoute: typeof OnboardingPodnikRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/vitejte': {
      id: '/onboarding/vitejte'
      path: '/onboarding/vitejte'
      fullPath: '/onboarding/vitejte'
      preLoaderRoute: typeof OnboardingVitejteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/znacka': {
      id: '/onboarding/znacka'
      path: '/onboarding/znacka'
      fullPath: '/onboarding/znacka'
      preLoaderRoute: typeof OnboardingZnackaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/spravce/': {
      id: '/spravce/'
      path: '/'
      fullPath: '/spravce/'
      preLoaderRoute: typeof SpravceIndexRouteImport
      parentRoute: typeof SpravceRouteRoute
    }
    '/spravce/plany': {
      id: '/spravce/plany'
      path: '/plany'
      fullPath: '/spravce/plany'
      preLoaderRoute: typeof SpravcePlanyRouteImport
      parentRoute: typeof SpravceRouteRoute
    }
    '/spravce/prehled': {
      id: '/spravce/prehled'
      path: '/prehled'
      fullPath: '/spravce/prehled'
      preLoaderRoute: typeof SpravcePrehledRouteImport
      parentRoute: typeof SpravceRouteRoute
    }
    '/spravce/profil': {
      id: '/spravce/profil'
      path: '/profil'
      fullPath: '/spravce/profil'
      preLoaderRoute: typeof SpravceProfilRouteImport
      parentRoute: typeof SpravceRouteRoute
    }
    '/fotograf/foceni/$shoot': {
      id: '/fotograf/foceni/$shoot'
      path: '/foceni/$shoot'
      fullPath: '/fotograf/foceni/$shoot'
      preLoaderRoute: typeof FotografFoceniShootRouteImport
      parentRoute: typeof FotografRouteRoute
    }
    '/fotograf/knihovna/': {
      id: '/fotograf/knihovna/'
      path: '/knihovna'
      fullPath: '/fotograf/knihovna/'
      preLoaderRoute: typeof FotografKnihovnaIndexRouteImport
      parentRoute: typeof FotografRouteRoute
    }
    '/fotograf/knihovna/$venue': {
      id: '/fotograf/knihovna/$venue'
      path: '/knihovna/$venue'
      fullPath: '/fotograf/knihovna/$venue'
      preLoaderRoute: typeof FotografKnihovnaVenueRouteImport
      parentRoute: typeof FotografRouteRoute
    }
    '/klient/foceni/': {
      id: '/klient/foceni/'
      path: '/foceni'
      fullPath: '/klient/foceni/'
      preLoaderRoute: typeof KlientFoceniIndexRouteImport
      parentRoute: typeof KlientRouteRoute
    }
    '/klient/foceni/brief': {
      id: '/klient/foceni/brief'
      path: '/foceni/brief'
      fullPath: '/klient/foceni/brief'
      preLoaderRoute: typeof KlientFoceniBriefRouteImport
      parentRoute: typeof KlientRouteRoute
    }
    '/klient/profil/': {
      id: '/klient/profil/'
      path: '/profil'
      fullPath: '/klient/profil/'
      preLoaderRoute: typeof KlientProfilIndexRouteImport
      parentRoute: typeof KlientRouteRoute
    }
    '/klient/profil/fakturace': {
      id: '/klient/profil/fakturace'
      path: '/profil/fakturace'
      fullPath: '/klient/profil/fakturace'
      preLoaderRoute: typeof KlientProfilFakturaceRouteImport
      parentRoute: typeof KlientRouteRoute
    }
    '/klient/profil/nastaveni': {
      id: '/klient/profil/nastaveni'
      path: '/profil/nastaveni'
      fullPath: '/klient/profil/nastaveni'
      preLoaderRoute: typeof KlientProfilNastaveniRouteImport
      parentRoute: typeof KlientRouteRoute
    }
    '/klient/profil/podklady': {
      id: '/klient/profil/podklady'
      path: '/profil/podklady'
      fullPath: '/klient/profil/podklady'
      preLoaderRoute: typeof KlientProfilPodkladyRouteImport
      parentRoute: typeof KlientRouteRoute
    }
    '/spravce/chaty/': {
      id: '/spravce/chaty/'
      path: '/chaty'
      fullPath: '/spravce/chaty/'
      preLoaderRoute: typeof SpravceChatyIndexRouteImport
      parentRoute: typeof SpravceRouteRoute
    }
    '/spravce/chaty/$client': {
      id: '/spravce/chaty/$client'
      path: '/chaty/$client'
      fullPath: '/spravce/chaty/$client'
      preLoaderRoute: typeof SpravceChatyClientRouteImport
      parentRoute: typeof SpravceRouteRoute
    }
    '/spravce/foceni/$shoot': {
      id: '/spravce/foceni/$shoot'
      path: '/foceni/$shoot'
      fullPath: '/spravce/foceni/$shoot'
      preLoaderRoute: typeof SpravceFoceniShootRouteImport
      parentRoute: typeof SpravceRouteRoute
    }
    '/spravce/klienti/': {
      id: '/spravce/klienti/'
      path: '/klienti'
      fullPath: '/spravce/klienti/'
      preLoaderRoute: typeof SpravceKlientiIndexRouteImport
      parentRoute: typeof SpravceRouteRoute
    }
    '/spravce/klienti/$client': {
      id: '/spravce/klienti/$client'
      path: '/klienti/$client'
      fullPath: '/spravce/klienti/$client'
      preLoaderRoute: typeof SpravceKlientiClientRouteImport
      parentRoute: typeof SpravceRouteRoute
    }
    '/spravce/kontrola/$client': {
      id: '/spravce/kontrola/$client'
      path: '/kontrola/$client'
      fullPath: '/spravce/kontrola/$client'
      preLoaderRoute: typeof SpravceKontrolaClientRouteImport
      parentRoute: typeof SpravceRouteRoute
    }
  }
}

interface FotografRouteRouteChildren {
  FotografChatRoute: typeof FotografChatRoute
  FotografDostupnostRoute: typeof FotografDostupnostRoute
  FotografPrehledRoute: typeof FotografPrehledRoute
  FotografProfilRoute: typeof FotografProfilRoute
  FotografVydelkyRoute: typeof FotografVydelkyRoute
  FotografIndexRoute: typeof FotografIndexRoute
  FotografFoceniShootRoute: typeof FotografFoceniShootRoute
  FotografKnihovnaVenueRoute: typeof FotografKnihovnaVenueRoute
  FotografKnihovnaIndexRoute: typeof FotografKnihovnaIndexRoute
}

const FotografRouteRouteChildren: FotografRouteRouteChildren = {
  FotografChatRoute: FotografChatRoute,
  FotografDostupnostRoute: FotografDostupnostRoute,
  FotografPrehledRoute: FotografPrehledRoute,
  FotografProfilRoute: FotografProfilRoute,
  FotografVydelkyRoute: FotografVydelkyRoute,
  FotografIndexRoute: FotografIndexRoute,
  FotografFoceniShootRoute: FotografFoceniShootRoute,
  FotografKnihovnaVenueRoute: FotografKnihovnaVenueRoute,
  FotografKnihovnaIndexRoute: FotografKnihovnaIndexRoute,
}

const FotografRouteRouteWithChildren = FotografRouteRoute._addFileChildren(
  FotografRouteRouteChildren,
)

interface KlientRouteRouteChildren {
  KlientChatRoute: typeof KlientChatRoute
  KlientKnihovnaRoute: typeof KlientKnihovnaRoute
  KlientPlanRoute: typeof KlientPlanRoute
  KlientPrehledRoute: typeof KlientPrehledRoute
  KlientIndexRoute: typeof KlientIndexRoute
  KlientFoceniBriefRoute: typeof KlientFoceniBriefRoute
  KlientProfilFakturaceRoute: typeof KlientProfilFakturaceRoute
  KlientProfilNastaveniRoute: typeof KlientProfilNastaveniRoute
  KlientProfilPodkladyRoute: typeof KlientProfilPodkladyRoute
  KlientFoceniIndexRoute: typeof KlientFoceniIndexRoute
  KlientProfilIndexRoute: typeof KlientProfilIndexRoute
}

const KlientRouteRouteChildren: KlientRouteRouteChildren = {
  KlientChatRoute: KlientChatRoute,
  KlientKnihovnaRoute: KlientKnihovnaRoute,
  KlientPlanRoute: KlientPlanRoute,
  KlientPrehledRoute: KlientPrehledRoute,
  KlientIndexRoute: KlientIndexRoute,
  KlientFoceniBriefRoute: KlientFoceniBriefRoute,
  KlientProfilFakturaceRoute: KlientProfilFakturaceRoute,
  KlientProfilNastaveniRoute: KlientProfilNastaveniRoute,
  KlientProfilPodkladyRoute: KlientProfilPodkladyRoute,
  KlientFoceniIndexRoute: KlientFoceniIndexRoute,
  KlientProfilIndexRoute: KlientProfilIndexRoute,
}

const KlientRouteRouteWithChildren = KlientRouteRoute._addFileChildren(
  KlientRouteRouteChildren,
)

interface SpravceRouteRouteChildren {
  SpravcePlanyRoute: typeof SpravcePlanyRoute
  SpravcePrehledRoute: typeof SpravcePrehledRoute
  SpravceProfilRoute: typeof SpravceProfilRoute
  SpravceIndexRoute: typeof SpravceIndexRoute
  SpravceChatyClientRoute: typeof SpravceChatyClientRoute
  SpravceFoceniShootRoute: typeof SpravceFoceniShootRoute
  SpravceKlientiClientRoute: typeof SpravceKlientiClientRoute
  SpravceKontrolaClientRoute: typeof SpravceKontrolaClientRoute
  SpravceChatyIndexRoute: typeof SpravceChatyIndexRoute
  SpravceKlientiIndexRoute: typeof SpravceKlientiIndexRoute
}

const SpravceRouteRouteChildren: SpravceRouteRouteChildren = {
  SpravcePlanyRoute: SpravcePlanyRoute,
  SpravcePrehledRoute: SpravcePrehledRoute,
  SpravceProfilRoute: SpravceProfilRoute,
  SpravceIndexRoute: SpravceIndexRoute,
  SpravceChatyClientRoute: SpravceChatyClientRoute,
  SpravceFoceniShootRoute: SpravceFoceniShootRoute,
  SpravceKlientiClientRoute: SpravceKlientiClientRoute,
  SpravceKontrolaClientRoute: SpravceKontrolaClientRoute,
  SpravceChatyIndexRoute: SpravceChatyIndexRoute,
  SpravceKlientiIndexRoute: SpravceKlientiIndexRoute,
}

const SpravceRouteRouteWithChildren = SpravceRouteRoute._addFileChildren(
  SpravceRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  FotografRouteRoute: FotografRouteRouteWithChildren,
  KlientRouteRoute: KlientRouteRouteWithChildren,
  SpravceRouteRoute: SpravceRouteRouteWithChildren,
  AktivaceRoute: AktivaceRoute,
  PrihlaseniRoute: PrihlaseniRoute,
  OnboardingFoceniRoute: OnboardingFoceniRoute,
  OnboardingHlasRoute: OnboardingHlasRoute,
  OnboardingHotovoRoute: OnboardingHotovoRoute,
  OnboardingListkyRoute: OnboardingListkyRoute,
  OnboardingNapojeniRoute: OnboardingNapojeniRoute,
  OnboardingOdkazyRoute: OnboardingOdkazyRoute,
  OnboardingPodnikRoute: OnboardingPodnikRoute,
  OnboardingVitejteRoute: OnboardingVitejteRoute,
  OnboardingZnackaRoute: OnboardingZnackaRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
